import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Box, Container, Grid } from '@material-ui/core';
import ProductsFilter from '../ProductsFilter';
import ProductsLimit from '../ProductsLimit';
import ProductsPagination from '../ProductsPagination';
import ProductResults from './ProductResults';
import ProductSearchExport from '../../containers/ProductSearchExport';

const useStyles = makeStyles((theme) => ({
  page: {
    backgroundColor: theme.palette.background.paper,

    '& > div': {
      width: '100%',
    },
  },
}));

const ProductPage = ({ q, products = [], total = 0 }) => {
  const cls = useStyles();

  return (
    <Box className={cls.page}>
      <Container maxWidth="xl">
        <Grid container justifyContent="space-between">
          <Grid item>
            <ProductsFilter query={q} />
          </Grid>
          <Grid item>
            <Grid container spacing={1}>
              <Grid item>
                <ProductSearchExport query={q} />
              </Grid>
              <Grid item>
                <ProductsLimit />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <ProductResults list={products} />
        </Grid>
        {products.length > 0 && (
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <ProductsPagination total={total} perPage={16} />
          </Grid>
        )}
      </Container>
    </Box>
  );
};

ProductPage.defaultProps = {
  q: '?',
  products: [],
  total: 0,
};

ProductPage.propTypes = {
  q: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
};

export default ProductPage;
